import { Injectable } from '@angular/core';
import { Globals } from '../../../../globals';
import { AssessmentDataModel } from '@api/models';
import { tap } from 'rxjs/operators';
import { LoggingService } from '@core/services/logging.service';
import {ClientFilterParams, ClientService} from '@api/services/client.service';
import { CaseService } from '../../../../api/services/case.service';

@Injectable({
  providedIn: 'root',
})
export class EmploymentReadinessAssessmentDataService {
  get isReadOnly() {
    return this.globals.viewType === 'VIEW';
  }
  constructor(
    private globals: Globals, 
    private logSvc: LoggingService,
    private caseSvc : CaseService
  ) 
    {
    }

  private _canShowCreateReadinessAssessment : boolean = false;
  set ShowCreateReadinessAssessment (bool: boolean) {
    this._canShowCreateReadinessAssessment = bool;
  }
  get ShowCreateReadinessAssessment() {
    return this._canShowCreateReadinessAssessment;
  }

  get caseKey() {
    const caseKey = this.globals.caseKey;
    if (!caseKey) {
      this.logSvc.logError({ lvl: 'WARN', mssg: 'no caseKey set in globals ' });
    }
    return caseKey;
  }

  public assessmentType = 'CLIENT';
  public assessmentTitle = 'Employment Readiness Assessment';

  private _assessments: AssessmentDataModel[] = [];
  
    get assessments$() {
      const caseKey = this.caseKey;
      if (!caseKey) {
        this.logSvc.logError({ lvl: 'WARN', mssg: `${this.constructor.name}.questionaire has no client key set.` });
      }
      return this.caseSvc
        .apiEmploymentReadinessAssessmentsGet$Json({
          parentCaseKey: caseKey,
        })
        .pipe(tap<Array<AssessmentDataModel>>((qs) => (this.assessments = [...qs])));
    }
  
    set assessments(ass: AssessmentDataModel[]) {
      this._assessments = ass;
    }
    get assessments() {
      return this._assessments;
    }

    get hasAssessments() : boolean {
      return this?.assessments?.length > 0;
    }
}
